import React from 'react';
import ReactDOM from 'react-dom';
import useOutsideAlerter from 'corp/hooks/useOutsideAlerter';
// https://dev.to/link2twenty/react-using-portals-to-make-a-modal-2kdf
const Portal: React.FC<{ onOutsideClick?: () => void; children?: React.ReactNode }> = ({
  children,
  onOutsideClick,
}) => {
  // Create div to contain everything
  const el = React.useMemo(() => document.createElement('div'), []);
  const wrapperRef = React.useRef(el);
  useOutsideAlerter(wrapperRef, () => onOutsideClick && onOutsideClick());
  React.useEffect(() => {
    const target = document.body;
    // Default classes
    const classList = ['portal-container'];
    classList.forEach(item => el.classList.add(item));
    // Append element to dom
    target.appendChild(el);
    // On unmount function
    return () => {
      // Remove element from dom
      target.removeChild(el);
    };
  }, [el]);
  // return the createPortal function
  return ReactDOM.createPortal(children, el);
};

export default Portal;
